import React from "react";
import { pickBy } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import { objectValuesMap } from "./mapping";

const fromParam = param => {
	if (typeof param !== "string") {
		throw new Error("param is not string");
	}

	const res = param.split(",");

	if (res.length === 1) {
		return res[0];
	}

	return res;
};

const toParam = param => {
	if (typeof param === "object" && Array.isArray(param) && param !== null) {
		return param.map(String).join(",");
	}

	return String(param);
};

const fromParams = params => objectValuesMap(params, fromParam);
const toParams = params => objectValuesMap(params, toParam);

const useQueryParams = () => {
	const history = useHistory();
	const { search, pathname } = useLocation();

	const params = React.useMemo(
		() => Object.fromEntries(new URLSearchParams(search).entries()),
		[search]
	);

	const paramsView = React.useMemo(() => fromParams(params), [params]);

	const setParams = React.useCallback(
		params => {
			const paramsValue = pickBy(
				typeof params === "function" ? params(paramsView) : params,
				v => v !== undefined
			);

			history.replace({
				pathname,
				search: new URLSearchParams(toParams(paramsValue)).toString()
			});
		},
		[history, pathname, paramsView]
	);

	return [paramsView, setParams];
};

export default useQueryParams;
